import { render, staticRenderFns } from "./EditorSideSummary.vue?vue&type=template&id=0b3d8bda&scoped=true&"
import script from "./EditorSideSummary.vue?vue&type=script&lang=ts&"
export * from "./EditorSideSummary.vue?vue&type=script&lang=ts&"
import style0 from "./EditorSideSummary.vue?vue&type=style&index=0&id=0b3d8bda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3d8bda",
  null
  
)

export default component.exports